import React, { Fragment, useState } from 'react';
import { BootstrapToolTip } from '@/_elements/ToolTip';
import { BiArchiveIn, BiArchiveOut } from 'react-icons/bi';
import JobPostForm from './JobPostForm';
import Swal from 'sweetalert2';
import { jobPostApi } from '@/_services/api/jobPost';
import { toast } from 'react-toastify';
import { VscLoading } from 'react-icons/vsc';
import { ActionStyles, AdminTable } from '@/components/Admin/reusableStyles';
import { GoToChannel } from '@/_elements/Links';
import TextViewWithEllipsis from '@/_elements/Text/TextViewWithEllipsis';
import { ViewUserForm } from '@/components/Admin/Form/SubmittedForm';
import { FaWpforms } from 'react-icons/fa';
import JobPostQuestionsForm from './JobPostQuestionsForm';

export default function JobPostTable({ results, onEdit, onArchive, page, limit, teamDetails }) {
    const [isBusy, setIsBusy] = useState(null);

    const handleArchive = async (item) => {
        try {
            const confirm = await Swal.fire({
                title: `Are you sure you want to archive ${item?.title || ''}?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Confirm',
            });
            if (confirm) {
                setIsBusy(item._id);
                await jobPostApi.archiveJobPost(item._id);
                await onArchive();
            }
            toast.success('Archived successfully!');
        } catch (error) {
            toast.error(error?.message || 'Something went wrong!');
        } finally {
            setIsBusy(false);
        }
    };

    const handleUnarchive = async (item) => {
        try {
            const confirm = await Swal.fire({
                title: `Are you sure you want to unarchive ${item?.title || ''}?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Confirm',
            });
            if (confirm) {
                setIsBusy(item._id);
                await jobPostApi.unarchiveJobPost(item._id);
                await onArchive();
            }
            toast.success('Unarchived successfully!');
        } catch (error) {
            toast.error(error?.message || 'Something went wrong!');
        } finally {
            setIsBusy(false);
        }
    };

    return (
        <AdminTable>
            <thead>
                <tr>
                    <th>SN</th>
                    <th>Title</th>
                    <th>Pay Range</th>
                    <th>Channel</th>
                    <th>Status</th>
                    <th style={{ width: '120px' }}>Actions</th>
                </tr>
            </thead>
            <tbody>
                {results.map((item, index) => {
                    return (
                        <tr key={item._id}>
                            <td width="30px">{(page - 1) * limit + index + 1}.</td>
                            <td>
                                <TextViewWithEllipsis text={item.title} lines={2} />
                            </td>
                            <td>{(item?.payRange || {})?.previewText || ''}</td>
                            <td>
                                <GoToChannel channel={item?.chatroomData} />
                            </td>
                            <td>
                                {item?.archived ? (
                                    <span className="badge badge-danger ">Archived</span>
                                ) : (
                                    <span className="badge badge-success ">Active</span>
                                )}
                            </td>
                            <td>
                                <ActionStyles>
                                    <JobPostForm item={item} viewMode={true} />
                                    {item?.userFormData && (
                                        <ViewUserForm id={item?.userFormData}>
                                            <BootstrapToolTip text="Form">
                                                <FaWpforms className="icon " />
                                            </BootstrapToolTip>
                                        </ViewUserForm>
                                    )}
                                    <JobPostQuestionsForm item={item} />
                                    <Fragment>
                                        <JobPostForm item={item} onEdit={onEdit} teamDetails={teamDetails} />
                                        {isBusy === item._id ? (
                                            <VscLoading className="spin" size={24} />
                                        ) : (
                                            <Fragment>
                                                {item.archived ? (
                                                    <BootstrapToolTip text="Unarchive">
                                                        <BiArchiveOut
                                                            onClick={() => handleUnarchive(item)}
                                                            className="icon assign"
                                                        />
                                                    </BootstrapToolTip>
                                                ) : (
                                                    <BootstrapToolTip text="Archive">
                                                        <BiArchiveIn
                                                            onClick={() => handleArchive(item)}
                                                            className="icon archiveIn"
                                                        />
                                                    </BootstrapToolTip>
                                                )}
                                            </Fragment>
                                        )}
                                    </Fragment>
                                </ActionStyles>
                                <div className="d-flex"></div>
                            </td>
                        </tr>
                    );
                })}
            </tbody>
        </AdminTable>
    );
}
